var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isProcessing === true)?_c('div',{staticClass:"fullview"},[_c('div',{staticClass:"loading-spacer"}),_c('vue-loading',{attrs:{"type":"spiningDubbles","color":"#aaa","size":{ width: '100px', height: '100px' }}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }